import { render, staticRenderFns } from "./MessageCards.vue?vue&type=template&id=cb8b24ee&scoped=true&"
import script from "./MessageCards.vue?vue&type=script&lang=js&"
export * from "./MessageCards.vue?vue&type=script&lang=js&"
import style0 from "./MessageCards.vue?vue&type=style&index=0&id=cb8b24ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8b24ee",
  null
  
)

export default component.exports